import React from 'react';
import { GoogleMap, GoogleApiWrapper, GoogleApiComponent } from '@react-google-maps/api';

class Contact extends React.Component {
    componentDidMount() {

    }



    render() {
        var center = {
            lat: -3.745,
            lng: -38.523
        };
        var containerStyle = {
            width: '400px',
            height: '400px'
        };

        return (
            <div class='fullwidthcontainer'>
                <div class='container80pctbg floatrelative center'>
                    <br />
                    <br />
                    <div class='header1'>Augenstern Schmuck e.K.</div>
                    <div class='header2'>Alexandra Gabriele Faltermeier</div>
                    <br />
                    <div class='text fullwidthcontainer'>

                        <div class="col50img floatrelative centercontainer">
                            <img src="./assets/phone.png" class="icon floatrelative" />
                        </div>
                        <div class="col50img floatrelative centercontainer">
                            <img src="./assets/mail.png" class="icon floatrelative" />
                        </div>
                        <div class="col50txt  floatrelative centercontainer">
                            (+49) 151 11198897
                        </div>
                        <div class="col50txt floatrelative centercontainer">
                            <a href="mailto:info@augenstern-schmuck.de">info@augenstern-schmuck.de</a>
                        </div>
                        <div class="col50img floatrelative centercontainer">
                            <img src="./assets/insta.png" class="icon floatrelative" />
                        </div>
                        <div class="col50img floatrelative centercontainer">
                            &nbsp;
                        </div>
                        <div class="col50txt floatrelative centercontainer">
                            <a href="https://www.instagram.com/augenstern_schmuck_straubing_/" target="_blank" rel="noreferrer">augenstern_schmuck_straubing_</a>
                        </div><div class="col50txt floatrelative centercontainer">
                            &nbsp;
                        </div>
                    </div>
                    <br />
                    <br />
                    <div class='header1'>Showroom</div>
                    <div class='text'>
                        Stadtgraben 34<br />
                        94368 Straubing<br />
                    </div>
                    <div class='fullwidthcontainer'>
                        {/* <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={10}>
                        </GoogleMap> */}
                    </div>
                    <br />
                    <div class='header2'>Öffnungszeiten</div>
                    <div class='text'>
                        Donnerstag &amp; Freitag 10:00 - 17:00 Uhr<br />
                        und nach Vereinbarung
                    </div>
                    <br />
                    <br />
                </div>
            </div >
        );
    }
}
export default (Contact);
